import { requests }  from "./request";

export const Practitioners = {
    all: () => requests.get('/practitioners'),
    search: (payload) => requests.get('/practitioners/search', {search: payload}),
    profil: (payload) => requests.get('/practitioners/' + payload + '/profil'),
    getConsultations: (payload) => requests.get('/practitioners/' + payload + '/appointments'),
    searchConsultation: (payload) => requests.get('/practitioners/' + payload.uuid + '/appointments/search', {search:payload.search}),
    getSignature: (payload) => requests.get('/practitioners/'+ payload +'/signature'),
    getCNI: (payload) => requests.get('/practitioners/'+ payload +'/cni'),
    setSignature: (payload) => requests.post('/practitioners/'+ payload.id +'/signature', payload.file),
    setCNI: (payload) => requests.post('/practitioners/' + payload.id + '/cni', payload.file),
    update: (payload) => requests.patch('/practitioners/' + payload.id, payload.data),
    synchronisePlatform: (payload) => requests.post('/practitioners/' + payload.id + '/synchronize'),
};

export const Users = {
    codes: (payload) => requests.get('/user/' + payload + '/codes'),
    sendAuthenticationCode: (payload) => requests.post('/user/' + payload.id + '/codes', {channel: payload.channel}),
    resetPasswordToken: (payload) => requests.get('/user/' + payload.id + '/reset_password'),
};

export const Consultations = {
    all: () => requests.get('/appointments'),
    search: (payload) => requests.get('/appointments/search', {search: payload}),
    details: (payload) => requests.get('/appointments/' + payload + '/details'),
    unlock: (payload) => requests.post('/appointments/' + payload + '/unlock')
};

export const Patients = {
    all: () => requests.get('/patients'),
    search: (payload) => requests.get('/patients/search', { search: payload }),
    profil: (payload) => requests.get('/patients/' + payload + '/profil'),
    getConsultations: (payload) => requests.get('/patients/' + payload + '/appointments'),
    searchConsultations: (payload) => requests.get('/patients/' + payload.uuid + '/appointments/search', {search: payload.search}),
    update: (payload) => requests.patch('/patients/' + payload.id, payload.data),
};

export const Statistics = {
    dashboard: () => requests.get('/dashboard'),
};

export const Languages = {
    all: (payload) => requests.get('/languages', payload.data),
    update: (payload) => requests.patch('/languages/'+payload.data.id, payload.data),
    search: (payload) => requests.get('/languages/search', { search: payload }),
    delete: (payload) => requests.delete('/languages/'+payload.data.id, payload.data)
}

export const Pharmacies = {
    update: (payload) => requests.patch('/pharmacies/'+payload.data.id, payload.data),
    search: (payload) => requests.get('/pharmacies', { search: payload }),
    get: (payload) => {
        return requests.get('/pharmacies/' + payload)
    }
}

export const Providers = {
    listProviders: (payload) => requests.get('/providers')
}
export const Specialties = {
    all: () => requests.get('/specialties')
}

export const Conventions = {
    all: () => requests.get('/conventions')
}

export const Premium = {
    get: (payload) => {
/*
        return requests.get('/premium/slot/patient/' + payload.data.id)
*/
    },
    create: () => requests.post('premium/slot')
}


// WEBPACK FOOTER //
// ./src/api/index.js